import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as IconAcompanamiento } from '../../../../assets/asideMenu/icon_acompanamiento.svg';
import { ReactComponent as IconDashboard } from '../../../../assets/asideMenu/icon_dashboard.svg';
import { ReactComponent as IconNotifications } from '../../../../assets/asideMenu/icon_notifications.svg';
import { ReactComponent as IconOval } from '../../../../assets/asideMenu/icon_oval.svg';
import { ReactComponent as IconRecursos } from '../../../../assets/asideMenu/icon_recursos.svg';
import styles from '../Layout/layout.module.scss';
import { useTranslation } from 'react-i18next';

export interface MenuMiembroProps {
  isOpenMenu: boolean;
  canViewNotifications: boolean;
  canViewAcompanamiento: boolean;
  canReadDonacionOwn: boolean;
  canPublishComunicaciones: boolean;
  canViewRecursos: boolean;
  hasUnreadAlerts: boolean;
  isMiembro: boolean;
  isAdmin: boolean;
  isOnlyMiembro: boolean;
  styleRoute: (route: string) => string;
}

const MenuMiembro: React.FC<MenuMiembroProps> = ({
  isOpenMenu,
  canViewNotifications,
  canViewAcompanamiento,
  canReadDonacionOwn,
  canPublishComunicaciones,
  canViewRecursos,
  hasUnreadAlerts,
  isMiembro,
  isAdmin,
  isOnlyMiembro,
  styleRoute,
}) => {
  const location = useLocation();
  const { t } = useTranslation();

  const inicio = '/';
  const mis_donaciones = '/mis-donaciones';
  const acompanamiento = '/acompanamiento';
  const comunicacion_nueva = '/comunicacion/nueva';
  const notificaciones = '/notificaciones';
  const perfil = '/perfil';
  const recursos = '/recursos';
  return (
    <ul className={styles.mainMenu}>
      {isOnlyMiembro && (
        <li className={`${styleRoute(inicio)}`}>
          <Link
            data-testid="dashboardLink"
            title={t('MenuInicio')}
            className={styles.menuLink}
            to={inicio}
          >
            <div className={styles.iconWrapper}>
              <IconDashboard className={styles.menuIcon} />
            </div>
            <span
              data-testid={
                isOpenMenu ? 'isDashboardVisible' : 'isDashboardHidden'
              }
              className={styles.menuText}
            >
              {t('MenuInicio')}
            </span>
          </Link>
        </li>
      )}
      {canReadDonacionOwn && (
        <li className={`${styleRoute(mis_donaciones)}`}>
          <Link
            data-testid="misdonacionesLink"
            className={styles.menuLink}
            to={mis_donaciones}
            title={t('MenuMisDonaciones')}
          >
            <div className={styles.iconWrapper}>
              <FontAwesomeIcon
                icon={['fas', 'piggy-bank']}
                size="lg"
                className={styles.menuIcon}
              />
            </div>
            <span
              data-testid={
                isOpenMenu ? 'isMisDonacionesVisible' : 'isMisDonacionesHidden'
              }
              className={styles.menuText}
            >
              {t('MenuMisDonaciones')}
            </span>
          </Link>
        </li>
      )}
      {canViewAcompanamiento && (
        <li className={`${styleRoute(acompanamiento)}`}>
          <Link
            data-testid="usersLink"
            className={styles.menuLink}
            to={acompanamiento}
            title={t('MenuAcompanamiento')}
          >
            <div className={styles.iconWrapper}>
              <IconAcompanamiento className={styles.menuIcon} />
            </div>
            <span
              data-testid={
                isOpenMenu
                  ? 'isAcompanamientoVisible'
                  : 'isAcompanamientoHidden'
              }
              className={styles.menuText}
            >
              {t('MenuAcompanamiento')}
            </span>
          </Link>
        </li>
      )}
      {/*canPublishComunicaciones && (
        <li className={`${styleRoute(comunicacion_nueva)}`}>
          <Link
            data-testid="comunicacionNuevaLink"
            className={styles.menuLink}
            to={comunicacion_nueva}
            title={t('MenuComunicarFallecimiento')}
          >
            <div className={styles.iconWrapper}>
              <FontAwesomeIcon
                icon={['fas', 'mail-bulk']}
                size="lg"
                className={styles.menuIcon}
              />
            </div>
            <span
              data-testid={
                isOpenMenu
                  ? 'isComunicacionNuevaVisible'
                  : 'isComunicacionNuevaHidden'
              }
              className={styles.menuText}
            >
              {t('MenuFallecimiento')}
            </span>
          </Link>
        </li>
      )*/}
      {canViewNotifications && (
        <li
          className={`${styleRoute(notificaciones)} ${styles.isNotification}`}
        >
          <Link
            data-testid="notificationsLink"
            className={styles.menuLink}
            to={notificaciones}
            title={t('MenuAlertas')}
          >
            <div
              className={`${styles.iconWrapper} ${
                hasUnreadAlerts ? styles.alarmAnimation : ''
              }`}
            >
              {hasUnreadAlerts && <IconOval className={styles.alarmOval} />}
              <IconNotifications className={styles.menuIcon} />
            </div>
            <span className={styles.menuText}>{t('MenuAlertas')}</span>
          </Link>
        </li>
      )}
      {canViewRecursos && (
        <li className={`${styleRoute(recursos)}`}>
          <Link
            data-testid="recursosLink"
            className={styles.menuLink}
            to={recursos}
            title={t('MenuRecursos')}
          >
            <div className={styles.iconWrapper}>
              <IconRecursos className={styles.menuIcon} />
            </div>
            <span className={styles.menuText}>{t('MenuRecursos')}</span>
          </Link>
        </li>
      )}
      <li
        className={`${styleRoute(perfil)} ${
          !canViewNotifications ? styles.isNotification : ''
        }`}
      >
        <Link
          className={`${styles.menuLink}`}
          data-testid="perfilLink"
          to={
            isMiembro
              ? perfil
              : isAdmin
                ? `${perfil}/seguridad`
                : `${perfil}/datos`
          }
          title={t('MenuMiPerfil')}
        >
          <div className={styles.iconWrapper}>
            <FontAwesomeIcon
              icon={['fas', 'user-circle']}
              size="lg"
              className={styles.menuIconPerfil}
            />
          </div>
          <span className={styles.menuText}>{t('MenuMiPerfil')}</span>
        </Link>
      </li>
    </ul>
  );
};

export default MenuMiembro;
